<template>
  <b-overlay :show="show" rounded="md">
    <b-modal
      id="modalpromotion"
      ref="modalpromotion"
      hide-footer
      size="lg"
      centered
    >
      <template #modal-header>
        <!-- Emulate built in modal header close button action -->
        <b-row> </b-row>
        <div
          style="
            text-align: center;
            background-color: #16b8e1;
            color: white;
            padding-top: 25px;
            text-align: center;
          "
          v-show="!showconfirm"
        >
          <h1>Get an Extra 10% off today!</h1>
          <h5>
            Plus, get sneak peeks at new product launches, special updates and
            exclusive offers!
          </h5>
        </div>
        <b-row>
          <h3
            style="
              position: absolute;
              top: 10px;
              right: 10px;
              color: white;
              cursor: pointer;
              padding-bottom: 20px;
              padding-left: 20px;
            "
            @click="closePromotionModal"
          >
            x
          </h3>
        </b-row>
      </template>

      <template #default>
        <b-row> </b-row>
        <div
          v-show="showconfirm"
          style="
            color: white;
            text-align: center;
            justify-content: center;
            padding-bottom: 30px;
          "
        >
          <h2>Thanks for subscribing</h2>
          <h5 style="color: white; text-align: center" class="pt-3">
            Your special Extra 10% offer has been applied sitewide!
          </h5>
          <div style="color: white; text-align: center" class="pt-3 pb-2">
            Get your Truthbrush Smart Trackers, Hubs and skins - & Start
            Brushing Better! Results Start Day1 !
          </div>
          <a href="/#/select">
            <b-button
              pill
              variant="primary"
              size="lg"
              class="buy_now_button"
              style="margin-top: 15px; margin-right: 0"
              >Order Now</b-button
            >
          </a>
        </div>
        <b-row v-show="!showconfirm">
          <b-col class="pl-pr-0-sm">
            <form
              ref="form"
              style="text-align: center; max-width: 500px; margin: 0 auto"
            >
              <b-form-group label-for="promotion-email-input">
                <b-form-input
                  id="promotion-email-input"
                  style="margin: 0 auto"
                  placeholder="Enter your email"
                  v-model="promotionemail"
                  :state="isEmptyString(promotionemail)"
                  required
                ></b-form-input>
              </b-form-group>
              <b-button
                pill
                variant="primary"
                size="lg"
                class="buy_now_button"
                style="
                  margin-top: 15px;
                  margin-right: 0;
                  width: auto !important;
                "
                @click="submitPromotionEmail"
                >Get 10% off now</b-button
              >
            </form>

            <b-row
              style="padding-top: 25px; color: white; text-align: center"
              class="pb-3"
            >
              By clicking “Get 10% off now”, I consent to the Truthbrush Privacy
              Policy and Terms of Use and agree to receive automated marketing
              messages at the email provided. Consent is not a condition of or
              required for any purchase.
            </b-row>
          </b-col>
        </b-row>
        <b-row> </b-row>
      </template>
    </b-modal>

    <b-container id="main-container" fluid style>
      <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
        <b-col class="" cols="12">
          <nav-header ref="header"></nav-header>
        </b-col>
      </b-row>
      <b-row
        class="banner"
        style="padding-top: 64px"
        v-if="getCoupon() == 'babysideburns' || getCoupon() == 'A3KzVdj8'"
        hidden
      >
        <a href="/#/select" style="color: white; align-self: center"
          >Baby Sideburns! Extra 10% off!</a
        >
      </b-row>
      

      <b-row class="main-jumbotron special-margin-top" style="">
        <b-col cols='12' v-if="getCoupon() == 'mylifesuckers'" class='banner'>
           <a href="/#/select" style="color: white; align-self: center"
          >MyLifeSuckers! Extra 10% off!</a
        >
        </b-col>
        <b-col cols='12' v-if="getCoupon() == 'peachjar0427'" class='banner'>
           <a href="/#/select" style="color: white; align-self: center"
          >Extra 20% off for LexRich5!</a
        >
        </b-col>
        <b-col cols='12' v-if="getCoupon() == 'TDm1cVpj'" class='banner'>
           <a href="/#/select" style="color: white; align-self: center"
          >Holiday Sales! Extra 10% off sitewide!</a
        >
        </b-col>
        <b-col cols='12' v-else class='banner' style=''>
           <a href="/#/select" style="color: white; display: flex; align-items:center; justify-content:center" 
          ><b-img src='img/header-truck.png' style='max-height:30px; margin-right:5px;'></b-img>
          <b-img src='img/header-penguin.png' style='max-height:30px; margin-right:5px;'></b-img>
          
              <span>Flash Sale - Extra 10% off</span>
              <b-img src='img/header-fox.png' style='max-height:30px; margin-left:5px;margin-right:5px;'></b-img>
              <b-img src='img/header-heart.png' style='max-height:30px; margin-right:5px;'></b-img>
          </a>
        </b-col>
        <b-col cols="12" class="pl-0 pr-0 hero-bk" style="">
          <b-container
            style="
              height: 100%;
              padding-left: 0;
              padding-right: 0;
              max-width: 100%;
              background-color:rgb(42,183,219);
              min-height:313px;
            "
          >
            <lottie-animation
            v-if="hide1"
            class="hide-when-sm-hero"
              ref="anim"
              :animationData="require('../assets/TBHero.json')"
              :loop="true"
              :autoPlay="true"
              :speed="1"
            />

            <lottie-animation
             v-if="hide2"
            class="hide-when-big-hero"
              ref="anim"
              :animationData="require('../assets/TBHero-mobile.json')"
              :loop="true"
              :autoPlay="true"
              :speed="1"
            />

            <div
              style="
                position: absolute;
                top: 0;
                color: white;
                width: 100%;
                height: 100%;
              "
            >
              <b-row
                class="hero-row hide-when-sm-hero"
                style="height: 100% !important"
              >
                <b-col cols="6" align-self="center">
                  <h1>Better Brushing,</h1>
                  <h1>Less Nagging.</h1>
                  <h3 class="pt-3 pr-5" hidden>
                    Works for all manual and electric toothbrushes
                  </h3>
                  <h3 class="pt-0 pr-5" >
                    Promo applied automatically
                  </h3>
                  <b-row class="ml-0 mt-3 lead pt-4 pb-4">
                    <b-col
                      style="text-align: left; max-width: 500px"
                      class="pl-0"
                    >
                      <a href="/#/select">
                        <b-button
                          pill
                          variant="primary"
                          size="lg"
                          class="buy_now_button"
                          >Order Now</b-button
                        >
                      </a>
                    </b-col>
                    <b-col class="pl-0">
                      <a>
                        <b-button
                          pill
                          variant="primary"
                          size="lg"
                          v-b-modal.how-it-works
                          class="how_it_works_button"
                          >Watch Video</b-button
                        >
                      </a>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col> </b-col>
              </b-row>

              <b-row
                class="hero-row hide-when-big-hero"
                style="height: 100% !important"
              >
                <b-col cols="12">
                  <h1>Better Brushing,</h1>
                  <h1>Less Nagging.</h1>
                  <h3 class="pt-3 pr-5" hidden>
                     New, monthly plans for as low as 99&#162;/mo/user
                  </h3>
                  <h3 class="pt-3 pr-5" hidden>
                    Works for all manual and electric toothbrushes
                  </h3>
                  <h3 class="pt-3 pr-5" hidden>
                    Get an Extra 10% Off today!
                  </h3>
                  <h3 class="pt-0" >
                    Promo applied automatically
                  </h3>
                  
                  <b-row class="ml-0 mt-3 lead pt-4 pb-4">
                    <b-col style="text-align: center">
                      <a href="/#/select" style="width: 100%">
                        <b-button
                          pill
                          variant="primary"
                          size="lg"
                          class="buy_now_button"
                          >Order Now</b-button
                        >
                      </a>
                    </b-col>
                    <b-col style="text-align: center">
                      <a style="width: 100%">
                        <b-button
                          pill
                          variant="primary"
                          size="lg"
                          v-b-modal.how-it-works
                          class="how_it_works_button"
                          >Watch Video</b-button
                        >
                      </a>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </b-container>
        </b-col>
      </b-row>

      <b-row
        style="width: 100%; padding-top: 80px; padding-bottom: 0px"
        align-h="center"
        class="main-jumbotron"
        ref="irene"
      >
        <b-col class="pl-0 pr-0">
          <b-row
            class="blue-text justify-content-center hide-when-small"
            data-aos="fade-up"
            data-aos-delay="250"
            hidden
          >
            Answers to 3 basic questions
          </b-row>

          <b-row
            class="justify-content-center"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <h1
              style="max-width: 100%; text-align: center !important"
              v-if="questiontitle == 0"
            >
              How does Truthbrush
              <h1 style="color: #12b8ed; text-align: center">
                Keep You On Track?
              </h1>
            </h1>
            <h1
              style="max-width: 100%; text-align: center !important"
              v-else-if="questiontitle == 1"
            >
              How does Truthbrush
              <h1 style="color: #12b8ed; text-align: center">
                Improve Performance?
              </h1>
            </h1>
            <h1
              style="
                max-width: 100%;
                text-align: center !important;
                padding-left: 0 !important;
                padding-right: 0 !important;
              "
              v-else
            >
              How does Truthbrush
              <h1
                style="
                  color: #12b8ed;
                  text-align: center;
                  padding-left: 0 !important;
                  padding-right: 0 !important;
                "
              >
                Develop Lasting Habits?
              </h1>
            </h1>
          </b-row>
          <b-row
            class="
              justify-content-center
              align-center
              sub-title2
              pl-3
              pr-3
              hide-when-small
            "
            v-if="questiontitle == 0"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Improving your family’s habits starts with understanding current
            behavior.
          </b-row>
          <b-row
            class="
              justify-content-center
              align-center
              sub-title2
              pl-3
              pr-3
              hide-when-small
            "
            v-else-if="questiontitle == 1"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Complete picture of your family’s brush habits allowing you to coach
            proper technique.
          </b-row>
          <b-row
            class="
              justify-content-center
              align-center
              sub-title2
              pl-3
              pr-2
              hide-when-small
            "
            v-else
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Truthbrush changes the way you interact, coach, and build positive
            habits with your family.
          </b-row>

          <b-row class="app-slider">
            <b-col class="pl-0 pr-0">
              <VueSlickCarousel
                @afterChange="afterChange"
                :arrows="false"
                :dots="true"
                :slidesToShow="3"
                :swipeToSlide="true"
                :touchThreshold="20"
                :centerMode="true"
                :centerPadding="'15%'"
                :responsive="[
                  {
                    breakpoint: 400,
                    settings: {
                      slidesToShow: 1,
                    },
                  },
                  {
                    breakpoint: 700,
                    settings: {
                      slidesToShow: 1,
                    },
                  },
                  {
                    breakpoint: 1080,
                    settings: {
                      slidesToShow: 2,
                    },
                  },
                  ,
                  {
                    breakpoint: 1380,
                    settings: {
                      slidesToShow: 3,
                    },
                  },
                ]"
              >
                <div class="abaserd" style="background-color: #555532">
                  <b-img
                    src="/img/q3-3.jpg"
                    class="question-image"
                    center
                    fluid
                  ></b-img>
                </div>
                <div style="background-color: blue">
                  <b-img
                    src="/img/q1-1.jpg"
                    class="question-image"
                    center
                    fluid
                  ></b-img>
                </div>
                <div>
                  <b-img
                    src="/img/q1-2.jpg"
                    class="question-image"
                    center
                    fluid
                  ></b-img>
                </div>
                <div>
                  <b-img
                    src="/img/q1-3.jpg"
                    class="question-image"
                    center
                    fluid
                  ></b-img>
                </div>
                <div>
                  <b-img
                    src="/img/q2-1.jpg"
                    class="question-image"
                    center
                    fluid
                  ></b-img>
                </div>
                <div>
                  <b-img
                    src="/img/q2-2.jpg"
                    class="question-image"
                    center
                    fluid
                  ></b-img>
                </div>
                <div>
                  <b-img
                    src="/img/q2-3.jpg"
                    class="question-image"
                    center
                    fluid
                  ></b-img>
                </div>
                <div>
                  <b-img
                    src="/img/q3-1.jpg"
                    class="question-image"
                    center
                    fluid
                  ></b-img>
                </div>
                <div>
                  <b-img
                    src="/img/q3-2.jpg"
                    class="question-image"
                    center
                    fluid
                  ></b-img>
                </div>
              </VueSlickCarousel>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row
        style="
          width: 100%;
          padding-top: 10px;
          padding-bottom: 60px;
          padding-top: 50px;
        "
        align-h="center"
        class="main-jumbotron"
      >
        <b-col class="pl-0 pr-0">
          <b-row
            class="blue-text justify-content-center"
            data-aos="fade-up"
            data-aos-delay="250"
          >
            Works beautifully
          </b-row>

          <b-row
            class="justify-content-center pt-3"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <h1 style="max-width: 100%">
              Customized Timer for cultivating brushing habits
            </h1>
          </b-row>
          <b-row
            class="
              justify-content-center
              align-center
              sub-title2
              pt-2
              pl-3
              pr-3
            "
            style="max-width: 700px; margin: auto !important"
            data-aos="fade-up"
            data-aos-delay="320"
          >
            It’s automatic! There is no start button, it knows when you are
            brushing and beeps when it's time to stop.
          </b-row>
          <b-row
            class="pt-5 hide-when-small"
            data-aos="fade-up"
            data-aos-delay="330"
          >
            <b-col class="pr-0 pl-0">
              <b-img-lazy src="/img/group-51-min.jpg" center fluid></b-img-lazy>
            </b-col>
          </b-row>
          <b-row
            class="pt-5 hide-when-big"
            data-aos="fade-up"
            data-aos-delay="330"
          >
            <b-col class="pr-0 pl-0">
              <b-img-lazy
                src="/img/group-51b-min.jpg"
                center
                fluid
              ></b-img-lazy>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row
        style="
          width: 100%;
          padding-bottom: 60px;

          background-color: #33383a;
        "
        align-h="center"
        class="main-jumbotron"
      >
        <b-col class="pl-pr-0-sm pt-5" style="">
          <b-row
            class="blue-text justify-content-center"
            style="color: #82c431"
            data-aos="fade-up"
            data-aos-delay="250"
          >
            One for all
          </b-row>

          <b-row
            class="justify-content-center pt-3"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <h1 style="max-width: 100%; color: white">
              Track your entire family’s brushing activity
            </h1>
          </b-row>
          <b-row
            class="
              justify-content-center
              align-center
              sub-title2
              pt-2
              pl-3
              pr-3;
            "
            style="max-width: 700px; margin: auto !important; color: white"
            data-aos="fade-up"
            data-aos-delay="320"
          >
            Truthbrush can support multiple trackers at same time. View entire
            family's performance in one app.
          </b-row>
          <b-row
            class="pt-5 hide-when-small"
            data-aos="fade-up"
            data-aos-delay="330"
          >
            <b-col>
              <b-img-lazy
                src="/img/family2-min.png"
                center
                fluid
                style="max-height: 660px"
              ></b-img-lazy>
            </b-col>
          </b-row>
          <b-row
            class="pt-5 hide-when-big"
            data-aos="fade-up"
            data-aos-delay="330"
          >
            <b-col cols="12" class="pl-0 pr-0 pb-4">
              <b-img-lazy
                src="/img/family1-min.jpg"
                fluid
                style="max-height: 660px"
              ></b-img-lazy>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row
        style="width: 100%; padding-bottom: 60px"
        align-h="center"
        class="main-jumbotron"
      >
        <b-col class="pl-0 pr-0 pt-5" style="">
          <b-row
            class="blue-text justify-content-center"
            style="color: #12b8ed"
            data-aos="fade-up"
            data-aos-delay="250"
          >
            Connects all your Truthbrush Trackers
          </b-row>

          <b-row
            class="justify-content-center pt-3"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <h1 style="max-width: 100%">
              Hub passively collects and passes all brush data
            </h1>
          </b-row>
          <b-row
            class="
              justify-content-center
              align-center
              sub-title2
              pt-2
              pl-3
              pr-3;
            "
            style="max-width: 700px; margin: auto !important"
            data-aos="fade-up"
            data-aos-delay="320"
          >
            No phone needs to be present. No app needs to be launched. No need
            to turn on Bluetooth.
          </b-row>
          <b-row class="pt-5">
            <b-col class="pl-0 pr-0 hide-when-small">
              <b-img-lazy
                src="/img/group55b-min.jpg"
                center
                fluid
                style="max-height: 660px"
              ></b-img-lazy>
            </b-col>
            <b-col class="pl-0 pr-0 hide-when-big">
              <b-img-lazy
                src="/img/group55c-min.jpg"
                center
                fluid
                style="max-height: 660px"
              ></b-img-lazy>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row align-h="center" class="main-jumbotron pt-5 pb-5 reduced-pb-0">
        <b-col class="pl-0 pr-0">
          <b-row
            class="blue-text justify-content-center"
            style="color: #00bea4"
            data-aos="fade-up"
            data-aos-delay="250"
          >
            Build great habits
          </b-row>

          <b-row
            class="justify-content-center pt-3"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <h1 style="max-width: 100%">Let the data speaks for itself</h1>
          </b-row>
          <b-row
            class="
              justify-content-center
              align-center
              sub-title2
              pt-2
              pl-3
              pr-3
              pb-4
            "
            style="max-width: 700px; margin: auto !important"
            data-aos="fade-up"
            data-aos-delay="320"
          >
            Truthbrush shows you where improvements are needed. It helps your
            family develop great brushing habits quickly and effectively.
          </b-row>
          <b-row class="padding-bottom-small">
            <b-col md="4" cols="12" class="pl-0 pr-0" style="z-index: 999">
              <b-row class="pt-2 pb-2">
                <b-col cols="12" style="text-align: center" class="pl-0 pr-0">
                  <div
                    style="padding-left: 0; color: #00bea4"
                    class="perm-title"
                  >
                    96%
                  </div>
                </b-col>
                <b-col
                  cols="12"
                  style="text-align: center; max-width: 490px"
                  class="align-center-small sub-title2"
                >
                  96% of users showed a significantly improved mouth coverage
                  score after first month.
                </b-col>
              </b-row>
            </b-col>

            <b-col md="4" cols="12" class="pl-0 pr-0" style="z-index: 999">
              <b-row class="pt-2 pb-2">
                <b-col cols="12" style="text-align: center" class="pl-0 pr-0">
                  <div
                    style="padding-left: 0; color: #00bea4"
                    class="perm-title"
                  >
                    > 90sec
                  </div>
                </b-col>
                <b-col
                  cols="12"
                  style="text-align: center; max-width: 490px"
                  class="align-center-small sub-title2"
                >
                  84% of users brush for longer than 90 seconds after 3 months
                  using Truthbrush.
                </b-col>
              </b-row>
            </b-col>
            <b-col md="4" cols="12" class="pl-0 pr-0" style="z-index: 999">
              <b-row class="pt-2 pb-2">
                <b-col cols="12" style="text-align: center" class="pl-0 pr-0">
                  <div
                    style="padding-left: 0; color: #00bea4"
                    class="perm-title"
                  >
                    62%
                  </div>
                </b-col>
                <b-col
                  cols="12"
                  style="text-align: center; max-width: 490px"
                  class="align-center-small sub-title2"
                >
                  62% of users improved their daily brush counts after 1 month,
                  with average improvement of 40%.
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row
        style="width: 100%; padding-bottom: 20px; background-color: #16b8e1"
        align-h="center"
        class="main-jumbotron"
      >
        <b-col class="pl-0 pr-0 pt-5" style="">
          <b-row>
            <b-col
              cols="12"
              style="
                text-align: center;
                background-color: #16b8e1;
                color: white;
                padding-top: 25px;
                text-align: center;
              "
              v-show="!showconfirm"
            >
              <h1 style="max-width: 100%">Get an Extra 10% off today!</h1>
            </b-col>
            <b-col
              style="text-align: center"
              v-show="!showconfirm"
              class="pt-3"
            >
              <h5 style="color: white">
                Plus, get sneak peeks at new product launches, special updates
                and exclusive offers!
              </h5>
            </b-col>
          </b-row>

          <b-row class="pt-3 pb-3">
            <b-col
              cols="12"
              v-show="showconfirm"
              style="color: white; text-align: center; justify-content: center"
            >
              <h1 style="max-width: 100%">Thanks for subscribing!</h1>
            </b-col>
            <b-col cols="12" v-show="showconfirm" class="pt-3 pb-2">
              <h5 style="color: white; text-align: center">
                Your special Extra 10% offer has been applied sitewide!
              </h5>
              <div style="color: white; text-align: center" class="pt-3">
                Get your Truthbrush Smart Trackers, Hubs and skins - & Start
                Brushing Better! Results Start Day1 !
              </div>
            </b-col>
            <b-col
              class="pt-3"
              cols="12"
              v-show="showconfirm"
              style="text-align: center"
            >
              <b-row>
                <b-col style="max-width: 500px; margin: 0 auto">
                  <a href="/#/select">
                    <b-button
                      pill
                      variant="primary"
                      size="lg"
                      class="buy_now_button"
                      style="margin-right: 0"
                      >Order now</b-button
                    >
                  </a>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="pl-pr-0-sm" v-show="!showconfirm">
              <form
                ref="form"
                style="text-align: center; max-width: 500px; margin: 0 auto"
              >
                <b-form-group
                  label-for="promotion-email-input"
                  class="pl-3 pr-3"
                >
                  <b-form-input
                    id="promotion-email-input"
                    style="margin: 0 auto"
                    placeholder="Enter your email"
                    v-model="promotionemail"
                    :state="isEmptyString(promotionemail)"
                    required
                  ></b-form-input>
                </b-form-group>
                <b-button
                  pill
                  variant="primary"
                  size="lg"
                  class="buy_now_button"
                  style="
                    margin-top: 15px;
                    margin-right: 0;
                    width: auto !important;
                  "
                  @click="submitPromotionEmail"
                  >Get 10% off now</b-button
                >
              </form>

              <b-row
                style="
                  padding-top: 25px;
                  color: white;
                  text-align: center;
                  justify-content: center;
                "
              >
                <b-col style="max-width: 600px">
                  By clicking “Get 10% off now”, I consent to the Truthbrush
                  Privacy Policy and Terms of Use and agree to receive automated
                  marketing messages at the email provided. Consent is not a
                  condition of or required for any purchase.
                </b-col>
              </b-row>
              
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row style="width: 100%">
        <nav-footer></nav-footer>
      </b-row>
      <b-row>
        <Checkout-Express id="my-modal" ref="my-modal"> </Checkout-Express>
      </b-row>
      <b-row>
        <b-modal
          id="how-it-works"
          hide-backdrop
          size="xl"
          centered
          title="BootstrapVue"
        >
          <b-embed
            type="iframe"
            aspect="16by9"
            src="https://www.youtube.com/embed/lzqr5TPsM0w"
            allowfullscreen
          ></b-embed>
        </b-modal>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import CheckoutExpress from "./../components/CheckoutExpress";
//import { Carousel, Slide } from "vue-carousel";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { promotionSignup } from "../api/store";
import storage from "../storage";
import store from "../store";
//import Lottie from "vue-lottie";
import LottieAnimation from "lottie-web-vue";

//import * as animationData from '../assets/pinjump.json';
export default {
  name: "Home",
  components: {
    NavHeader,
    NavFooter,
    CheckoutExpress,
    //Carousel,
    VueSlickCarousel,
    //Lottie,
    LottieAnimation,
    //Slide,
  },
  data() {
    return {
      hide1: true,
      hide2: true,
      defaultOptions: {
        animationData: require("../assets/TBHero.json"),
        renderer: "canvas",
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      },
      defaultOptionssm: {
        animationData: require("../assets/TBHero-mobile.json"),
        renderer: "canvas",
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      },
      LottieWidth: 400,
      animationSpeed: 5,
      state: 0,
      showconfirm: false,
      promotionemail: null,
      show: false,
      slide: 0,
      slide2: 0,
      question: 0,
      questiontitle: 0,
      aspect: "16:9",
      heroindex: 0,
      paginationColor: "#12B8ED",
      hoverindex: 0,
      hero1: true,
      video1: null,
      couponcode: "",
      settings: {
        arrows: true,
        dots: true,
      },
    };
  },

  mounted() {
    this.video_init();

    storage.clearstorestate();
    var coupon = storage.processCoupon();
    storage.saveCart2Store(this);

    if (coupon == null || coupon == 'dV7sL3vU') {
      console.log("coupon is null");
      var lastpop = storage.getPromotionPop();
      if (lastpop == null) {
        console.log("lastpop is null");
        this.showPromotion();
      } else {
        console.log("lastpop is valid");
        var diff = new Date().getTime() - lastpop;
        if (diff / 1000 / 3600 / 24 > 2) {
          console.log("lastpop more than 2 days");
          this.showPromotion();
        } else {
          console.log("lastpop too recent");
        }
      }
    } else {
      console.log("coupon is valid");
    }

  },
  computed: {
  },
  methods: {
    showPromotion() {
      var context = this;
      setTimeout(function () {
        try {
          context.$refs.modalpromotion.show();
          storage.savePromotionPop();
        } catch (err) {
          console.log(err);
        }
      }, 2000);
    },
    submitPromotionEmail() {
      if (this.isEmptyString(this.promotionemail)) {
        storage.initExtended(this.promotionemail);
        //storage.saveCoupon("sroBDBjg"); // default 10%
        storage.saveCoupon("dV7sL3vU");  // father's day
        
        storage.processCoupon();

        var signup = {};
        signup.email = this.promotionemail;

        promotionSignup(signup)
          .then(() => {
            //console.log("order info ok:" + res);
            this.showconfirm = true;
          })
          .catch(function () {
            //console.log("order info failed:" + err);
            this.showconfirm = true;
          });
      }
    },
    isEmptyString(promotionemail) {
      if (promotionemail == null) return null;

      var re = /\S+@\S+\.\S+/;
      return re.test(promotionemail);
    },
    closePromotionModal() {
      this.$refs.modalpromotion.hide();
    },
    afterChange(index) {
      //console.log(Math.floor((index/3)).toFixed(0))
      this.questiontitle = Math.floor(index / 3).toFixed(0);
    },
    getCoupon() {
      //console.log("get:" + store.state.couponid);
      return store.state.couponid;
    },
    video_init() {
      window._wq = window._wq || [];
      var context = this;
      window._wq.push({
        id: "3wuzoilyxh",
        onReady: function (video) {
          context.video1 = video;
        },
      });
    },
    video1_start() {
      this.video1.play();
    },
    mouseOver: function () {
      //console.log("in");
    },

    gotoshop() {
      window.location.href = "/#/select";
    },
  },
};
</script>

<style lang="scss">
#promotion-email-input {
  height: 3rem;
}

#modalpromotion .modal-content {
  background-color: #16b8e1;

  .modal-header {
    border-bottom: 0;
  }
}

.modal-backdrop {
  opacity: 0.65 !important;
}

.buy_now_button {
  background-color: #ffffff !important;
  border-color: #ffffff !important;
  color: #16b8e1 !important;
  width: 100%;
  font-weight: 600 !important;
}

.how_it_works_button {
  background-color: #0f819e !important;
  border-color: #0f819e !important;
  color: white;
  width: 100%;
  font-weight: 600 !important;
}

.fffaaa {
  background-color: #16b8e1;
  //height:560px;
}

.fffbbb {
  background-color: #00bea4;
  //height:560px;
}

.fffccc {
  background-color: #9775fa;
  //height:560px;
}

#how-it-works {
  header,
  footer {
    display: none;
  }
  .modal-body {
    padding: 0;
  }
}

.special-margin-top {
  margin-top: 60px;
}
.perm-title {
  font-size: 60px !important;
  font-weight: 700;
}
.banner {
  background-color: #2F95EB;
  color: white;
  padding: 5px 0;
  text-align: center;
  font-size: 16px;
  justify-content: center;
}

#modal {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.hero-bk {
  //background-image: url(/img/child-s-hand-holding-white-chalk-on-black-chalkboa-2021-08-27-23-43-50-utc-1-min.jpg);
  //background-position: 50% !important;
  //background-size: cover;
  //min-height: 680px !important;
  //background-repeat: no-repeat;
}

.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

#main-container {
  padding: 0;
  width: 100%;
  max-width: 100%;
}

.main-jumbotron h1 {
  font-family: "Circular-Bold";
  font-size: 30px;
  max-width: 650px;
}

.sub-title2 {
  font-size: 20px !important;
}

.first-hero-upper {
  padding-top: 60px;
}

.app-slider {
  padding-top: 40px;
}

.question-image {
  max-height: 50rem !important;
  margin: 0 auto;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 15px !important;
  -webkit-user-drag: none;
}

.blue-text {
  color: #12b8ed;
  font-size: 24px;
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
}

.align-center {
  text-align: center;
}

#modal .modal-body {
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

#modal .modal-header {
  border-bottom: 2px solid #d9dadb !important;
}

#modal .modal-footer {
  border-top: 2px solid #d9dadb !important;
}

.blue-button,
.blue-button:hover {
  background-color: #12b8ed !important;
  border: none !important;
  padding: 0 20px !important;
}

.btn-outline-primary {
  border: 1px solid #12b8ed !important;
}

.btn-outline-primary:hover {
  border: 1px solid #12b8ed !important;
  background-color: #12b8ed !important;
}

#my-modal___BV_modal_outer_ {
  z-index: 9999999999 !important;
}

.review-card {
  background-color: white;
  border-radius: 10px;
  min-height: 260px;
  padding-bottom: 20px;
}

.hero-row {
  padding-left: 8%;
  h1 {
    font-size: 45px;
    line-height: 1.3;
  }
  h3 {
    font-size: 24px;
    line-height: 1.5;
  }
}

@media (max-width: 1199px) {
  .hero-row {
    padding-left: 6%;
    h1 {
      font-size: 40px;
      line-height: 1.3;
    }
    h3 {
      font-size: 22px;
      line-height: 1.5;
    }
  }
}

@media (max-width: 978px) {
  .hero-row {
    padding-left: 6%;
    h1 {
      font-size: 38px;
      line-height: 1.3;
    }
    h3 {
      font-size: 20px;
      line-height: 1.5;
    }
  }
}

@media (max-width: 878px) {
  .buy_now_button {
    width: 47%;
    font-size: 16px;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .how_it_works_button {
    width: 47%;
    font-size: 16px;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .hero-row {
    padding-left: 6%;
    h1 {
      font-size: 36px;
      line-height: 1.3;
    }
    h3 {
      font-size: 18px;
      line-height: 1.5;
      padding-right: 0 !important;
    }
    .buy_now_button,
    .how_it_works_button {
      font-size: 15px !important;
      width: 100%;
    }
  }
}
@media (min-width: 769px) {
  .hide-when-big {
    display: none !important;
  }
}
@media (min-width: 581px) {
  .hide-when-big-hero {
    display: none !important;
  }
}

@media (max-width: 768px) {
  .hero-row {
    padding-left: 3%;
    .col-6 {
      padding-right: 0 !important;
      padding-left: 0 !important;
    }
    h1 {
      font-size: 36px!important;
      line-height: 1.1;
      text-align: left !important;
      padding-left: 0 !important;
    }
    h3 {
      font-size: 17px;
      line-height: 1.5;
      padding-right: 0 !important;
    }

    .buy_now_button,
    .how_it_works_button {
      font-size: 12px !important;
    }
  }

  .fffaaa {
    background-color: #16b8e1;
  }

  .fffbbb {
    background-color: #00bea4;
  }

  .fffccc {
    background-color: #9775fa;
  }

  .hero_img1 {
    padding-top: 0px;
    //max-height: 480px!important;
  }

  .app-slider {
    padding-top: 20px;
  }

  .special-margin-top {
    margin-top: 60px !important;
  }

  .perm-title {
    font-size: 40px !important;
  }
  .first-hero-upper {
    padding-top: 40px !important;
  }

  .align-center-small {
    text-align: center !important;
  }
  .padding-bottom-small {
    padding-bottom: 45px;
  }
  .pl-pr-0-sm {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .feature_carousel .slide .main-jumbotron {
    padding-top: 0rem !important;
  }

  .review-card {
    background-color: white;
    border-radius: 10px;
    min-height: 340px !important;
    padding-bottom: 20px;
  }

  #my-modal {
    padding-left: 0 !important;
  }

  #modal .modal-dialog {
    width: calc(100% - 1rem) !important;
  }

  #modal .modal-dialog,
  #modal .modal-content {
    max-height: 100% !important;
    height: calc(100% - 0.5rem) !important;
  }

  .btn-lg {
    font-size: 1.2rem !important;
    padding: 10px 20px !important;
  }

  .blue-text {
    color: #12b8ed;
    font-size: 20px !important;
    text-align: center;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
  }

  .hide-when-small {
    display: none !important;
  }

  .no-padding-left-small {
    padding-left: 0 !important;
  }
  .reduced-pb {
    padding-bottom: 25px !important;
  }

  .reduced-pb-0 {
    padding-bottom: 0 !important;
  }

  .reduced-pt-0 {
    padding-top: 0 !important;
  }

  .question-image {
    max-height: 45rem !important;
    margin: 0 auto;
    border-radius: 15px !important;
  }

  .main-jumbotron {
    padding-left: calc(50% - 600px + 45px) !important;
    padding-right: calc(50% - 600px + 45px) !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .main-jumbotron {
    h1 { text-align:center;}
  }
  .main-jumbotron.background-1 h1 {
    color: white !important;
  }

  .main-jumbotron.background-5 h1 {
    color: white !important;
  }

  .question-hide {
    display: none;
  }

  .sub-title2 {
    padding-top: 10px;
    margin: auto 0;
    font-size: 18px !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

@media (max-width: 580px) {
  .hide-when-sm-hero {
    display: none !important;
  }
  .hero-row {
    padding-top: 30px;
    padding-left: 0 !important;
    h1 {
      font-size: 36px !important;
      line-height: 1.1;
      text-align: center !important;
      padding-left: 0 !important;
    }
    h3 {
      font-size: 17px !important;
      line-height: 1.4;
      padding-right: 0 !important;
      text-align: center !important;
    }

    .row {
      padding-top: 10px !important;
    }

    .buy_now_button {
      margin-right: 0 !important;
    }
    .buy_now_button,
    .how_it_works_button {
      font-size: 15px !important;
      width: 100%;
    }
  }
}

@media (min-width: 1200px) {
  .main-jumbotron {
    padding-left: calc(50% - 720px + 45px) !important;
    padding-right: calc(50% - 720px + 45px) !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .buy_now_button,
    .how_it_works_button {
      font-size: 17px !important;
      width: 85%;
    }
}

@media (min-width:769px){
    #modal .modal-dialog {
    width: 380px !important;
  }

  #modal .modal-dialog,
  #modal .modal-content {
    max-height: 100% !important;
    margin-top: 0 !important;
    margin-bottom: 0!important;
    height:100%!important;
    max-height:100%!important;
    
  }
}

</style>

